import React from "react"
import Card, { CardProps } from "../Card"
import { twMerge } from "tailwind-merge"
import { IS_AGENT_APP, isAldeia } from "hooks/useAldeia"

interface CardLayoutProps extends CardProps {
  children: React.ReactNode
  className?: string
  headerClassName?: string
  layout?: "static" | "default" | "grid"
}

function CardLayout(props: CardLayoutProps) {
  const { children, className, headerClassName, ...rest } = props

  return (
    <Card
      className={twMerge(
        "kinbox:max-w-3xl w-full kinbox:mx-5 kinbox:mt-5 kinbox:mb-20 aldeia:shadow-none pb-4 mobile:shadow-none mobile:max-w-full mobile:p-0 mobile:m-0",
        // isAldeia && "[&>header]:border-b [&>header]:border-divider-100 [&>header]:border-solid",
        isAldeia && "[&>header]:!px-[30px] [&>header]:!pt-5 [&>header]:!pb-0 h-[var(--app-container-height)]",
        props.layout === "static" && "bg-base-200 g_static_page",
        props.layout === "grid" && "bg-base-200 g_grid_page g_static_page",
        props.className,
      )}
      headerClassName={twMerge(
        "mobile:hidden",
        props.headerClassName,
        // props.layout === "grid" && "max-w-[1280px] mx-auto"
      )}
      {...rest}
      style={{
        ...props.style,
        // boxShadow: "0 0 2px 0 rgba(0,0,0,0.12), 0 2px 6px 0 rgba(0,0,0,0.06), inset 0 0 0 1px rgba(255, 255, 255, 0.1)",
        // ...(IS_AGENT_APP ? { boxShadow: "-4px -4px 16px #00000017" } : {}),
        // ...(IS_AGENT_APP ? { boxShadow: "0 0 5px rgba(0, 0, 0, .05), 0 0 2px -1px rgba(0, 0, 0, .03)" } : {}),
      }}
    >
      {/* {props.layout === "grid" ? <div className="max-w-[1280px] mx-auto">{props.children}</div> : props.children} */}
      {props.children}
    </Card>
  )
}

export default CardLayout
